// extracted by mini-css-extract-plugin
export default {"borderBottom":"AdminMobileYearSaleStat_borderBottom__Zw1pn","prevIcon":"AdminMobileYearSaleStat_prevIcon__tnO2c","nextIcon":"AdminMobileYearSaleStat_nextIcon__3y+gF"};